import { PageRef } from 'providers/page-ref';

export type AdminImpersonatedUserPageParams = {};

export const IAdminImpersonatedUserPage: PageRef<AdminImpersonatedUserPageParams, void> = {
  pageName: 'AdminImpersonatedUserPage',
} as PageRef<AdminImpersonatedUserPageParams, void>;
